import { createReducer, on } from '@ngrx/store';
import * as CommentActions from './comment.actions';
import { Comment } from '../../models/Comment';

export interface CommentState {
  entitiesByOrder: { [reflexNo: string]: Comment[] };
  loading: boolean;
  error?: string | null;
}

export const initialState: CommentState = {
  entitiesByOrder: {},
  loading: false,
  error: null,
};

export const commentReducer = createReducer(
  initialState,
  on(CommentActions.loadCommentsByReflex, (state) => ({ ...state, loading: true, error: null })),
  on(CommentActions.loadCommentsByReflexSuccess, (state, { reflexNo, comments }) => ({
    ...state,
    loading: false,
    entitiesByOrder: { ...state.entitiesByOrder, [reflexNo]: comments },
  })),
  on(CommentActions.loadCommentsByReflexFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(CommentActions.addCommentSuccess, (state, { reflexNo, comment, clientId }) => {
    const list = state.entitiesByOrder[reflexNo] ?? [];
    if (clientId) {
      const idx = list.findIndex((c) => c.clientId === clientId);
      if (idx >= 0) {
        const newList = list.slice();
        newList[idx] = { ...comment };
        return { ...state, entitiesByOrder: { ...state.entitiesByOrder, [reflexNo]: newList } };
      }
    }
    return { ...state, entitiesByOrder: { ...state.entitiesByOrder, [reflexNo]: [...list, comment] } };
  }),
  // Optimistic updates
  on(CommentActions.addComment, (state, { reflexNo, commentText, clientId }) => {
    const list = state.entitiesByOrder[reflexNo] ?? [];
    const optimistic: Comment = {
      id: -1,
      commentText,
      orderReflexNo: reflexNo,
      clientId,
      createdDate: new Date(),
      changedDate: new Date(),
    } as unknown as Comment;
    return { ...state, entitiesByOrder: { ...state.entitiesByOrder, [reflexNo]: [...list, optimistic] } };
  }),
  on(CommentActions.deleteComment, (state, { reflexNo, id }) => {
    const list = state.entitiesByOrder[reflexNo] ?? [];
    return { ...state, entitiesByOrder: { ...state.entitiesByOrder, [reflexNo]: list.filter((c) => c.id !== id) } };
  }),
  on(CommentActions.updateCommentSuccess, (state, { comment }) => {
    const reflexNo = (comment as any).reflexOrderNo as string;
    const list = state.entitiesByOrder[reflexNo] ?? [];
    return {
      ...state,
      entitiesByOrder: {
        ...state.entitiesByOrder,
        [reflexNo]: list.map((c) => (c.id === comment.id ? { ...c, ...comment } : c)),
      },
    };
  }),
  on(CommentActions.deleteCommentSuccess, (state, { reflexNo, id }) => {
    const list = state.entitiesByOrder[reflexNo] ?? [];
    return {
      ...state,
      entitiesByOrder: {
        ...state.entitiesByOrder,
        [reflexNo]: list.filter((c) => c.id !== id),
      },
    };
  })
);
